module.exports = __webpack_public_path__ + "static/media/placecard.be90350e.jpeg";